import styled from '../../../../styles/styledComponents/themeComponents';

export const ViewStyle = styled.div`
  padding: 20px 0;

  .slide-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .slide-card {
    position: relative;
    width: 280px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }

    .slide-index {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.55);
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }

    .image-pair {
      display: flex;
      gap: 1px;
      background: #f0f0f0;

      .image-slot {
        flex: 1;
        position: relative;

        img {
          width: 100%;
          height: 100px;
          object-fit: cover;
          display: block;
        }

        .image-label {
          position: absolute;
          bottom: 4px;
          right: 4px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          font-size: 10px;
          font-weight: 600;
          padding: 1px 5px;
          border-radius: 3px;
        }
      }
    }

    .slide-meta {
      padding: 12px;
      border-top: 1px solid #f0f0f0;

      .meta-row {
        display: flex;
        gap: 8px;
        font-size: 12px;
        line-height: 1.8;

        .meta-label {
          color: #999;
          min-width: 30px;
          flex-shrink: 0;
          font-weight: 500;
        }

        .meta-value {
          color: #333;
          word-break: break-all;
        }
      }
    }
  }
`;
